import React from 'react';
import LateralMenu from '../LateralMenu';
import { faCar, faClipboardList, faFolderOpen, faSearch, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { translate } from '../../services/translate';
import logo from '../../../assets/logo_lpr.png';
import collapsedLogo from '../../../assets/icon_lpr.png';

export default function LprLateralMenu({ navigation, open, authenticatedUser, setOpen, selectedMenu }: LateralMenuProps) {

    const canWatchEvents = (
        authenticatedUser?.isAdmin
        || authenticatedUser?.permissions.lpr_module_access
        || authenticatedUser?.permissions.lpr_can_watch_all_events
    );

    return (
        <LateralMenu
            topImage={logo}
            collapsedTopImage={collapsedLogo}
            open={open}
            setOpen={setOpen}
            authenticatedUser={authenticatedUser}
            items={[{
                icon: faClipboardList,
                text: translate('liveEvents'),
                action: () => navigation.navigate('LPR', { screen: 'LprLiveEvents' }),
                selected: selectedMenu == 'live-events',
                omit: !canWatchEvents,
            }, {
                icon: faTriangleExclamation,
                text: translate('liveAlerts'),
                action: () => navigation.navigate('LPR', { screen: 'LprLiveAlerts' }),
                selected: selectedMenu == 'live-alerts',
                omit: !canWatchEvents,
            }, {
                icon: faSearch,
                text: translate('search'),
                action: () => navigation.navigate('LPR', { screen: 'LprSearch' }),
                selected: selectedMenu == 'search',
                omit: !canWatchEvents,
            }, {
                icon: faCar,
                text: translate('plates'),
                action: () => navigation.navigate('LPR', { screen: 'Plates' }),
                selected: selectedMenu == 'plates',
                omit: !((
                    authenticatedUser?.isAdmin
                    || authenticatedUser?.permissions.lpr_module_access
                    || authenticatedUser?.permissions.lpr_edit_denylist
                    || authenticatedUser?.permissions.lpr_see_denylist
                    || authenticatedUser?.permissions.lpr_edit_illegal_debris
                    || authenticatedUser?.permissions.lpr_see_illegal_debris
                )),
            }, {
                icon: faFolderOpen,
                text: translate('reports'),
                action: () => navigation.navigate('LPR', { screen: 'LprReports' }),
                selected: selectedMenu == 'reports',
                omit: !(
                    authenticatedUser?.isAdmin
                    || authenticatedUser?.permissions.lpr_module_access
                )
            }]}
        />
    );
}
